export default __webpack_public_path__ + "static/media/MVJ.9e18763c.png";